// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Types_CheckoutTrackingItem from "../Restaumatic.Analytics.Types.CheckoutTrackingItem/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(Restaumatic_Analytics_Types_CheckoutTrackingItem.eqCheckoutTrackingItem));
var itemsIsSymbol = {
    reflectSymbol: function () {
        return "items";
    }
};
var CheckoutTrackingDataIsSymbol = {
    reflectSymbol: function () {
        return "CheckoutTrackingData";
    }
};
var CheckoutTrackingData = function (x) {
    return x;
};
var toFillFormTypeCheckoutTra = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeCheckoutTrackingDa = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldCheckoutTrackingD = function (dictHasField) {
    return dictHasField;
};
var eqCheckoutTrackingData = {
    eq: function (x) {
        return function (y) {
            return eq(x.items)(y.items);
        };
    }
};
var genericCheckoutTrackingData = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCheckoutTrackingData = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCheckoutTrackingData)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(itemsIsSymbol)(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Analytics_Types_CheckoutTrackingItem.showCheckoutTrackingItem)))))(CheckoutTrackingDataIsSymbol))
};
var unscrambleDecodeCheckoutTrackingData = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCheckoutTrackingData)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(itemsIsSymbol)(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Analytics_Types_CheckoutTrackingItem.unscrambleDecodeCheckoutTrackingItem))(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var encodeCheckoutTrackingData = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCheckoutTrackingData)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CheckoutTrackingDataIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)(itemsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Analytics_Types_CheckoutTrackingItem.encodeCheckoutTrackingItem)))))))
};
var decodeCheckoutTrackingData = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCheckoutTrackingData)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CheckoutTrackingDataIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)(itemsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Analytics_Types_CheckoutTrackingItem.decodeCheckoutTrackingItem)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    CheckoutTrackingData,
    genericCheckoutTrackingData,
    eqCheckoutTrackingData,
    showCheckoutTrackingData,
    encodeCheckoutTrackingData,
    decodeCheckoutTrackingData,
    unscrambleDecodeCheckoutTrackingData,
    toFillFormTypeCheckoutTra,
    hasFieldCheckoutTrackingD,
    newtypeCheckoutTrackingDa
};
